import { z } from 'zod'

import mxTranslations from '../i18n/messages/es-MX.json'

/**
 * password schema
 * 提供给登录时，填写密码验证
 */
export const passwordSchema = z.object({
  password: z.string().trim().min(1, { message: mxTranslations?.Common?.required_field || 'This is a required field.' }),
})
